<template>
  <a-table
            :columns="columns"
            :rowKey="rowkeyGen"
            :dataSource="userData"
            :loading="loading"
            :pagination="false"
            :scroll="{x: 1000}"
            bordered
        >   
            <span slot="isActiveCol"
                slot-scope="isActive, record"
                :style="{
                    textAlign: 'center'
                }"
            >
                <a-popconfirm 
                    :title="`Biztos ${isActive ? 'in' : ''}aktiválja  a felhasználót?`"
                    okText="Igen"
                    cancelText="Nem"
                    v-on:confirm="switchUserActiveState(isActive, record)"
                >
                <a-switch
                    :checked="isActive"
                >
                    <a-icon type="unlock" slot="checkedChildren" />
                    <a-icon type="lock" slot="unCheckedChildren"/>
                </a-switch>
                </a-popconfirm>
            </span>
            <div
                slot="actions-col"
                slot-scope="record"
                :style="{width: '110px'}"
            >
                <a-button
                    icon="edit"
                    type="primary"
                    v-on:click="editUser(record)"
                    class="action-button"
                >
                </a-button>
                <a-popconfirm 
                    title="Biztos törli?"
                    okText="Igen"
                    cancelText="Nem"
                    v-on:confirm="deleteUser(record)"
                >
                    <a-button 
                        icon="delete"
                        class="action-button"
                    >
                    </a-button>
                </a-popconfirm>
                
            </div>
        </a-table>
</template>

<script>
export default {
    props: {
        userData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        columns() {
            const columns = [
            {
                dataIndex: 'email',
                title: 'E-mail',
                key: 'email',
                width: '25',
            },
            {
                dataIndex: 'isActive',
                title: 'Státusz',
                key: 'isActive',
                width: '25',
                scopedSlots: {
                    customRender: 'isActiveCol'
                }
            },
            {
                dataIndex: 'phone',
                title: 'Telefonszám',
                key: 'phone',
                width: '25',
            },
            {
                dataIndex: 'createdAt.date',
                title: 'Létrehozva',
                key: 'created',
                width: '25',
            },
            // {
            //     dataIndex: 'mediaFile.versions[0].size',
            //     title: 'Mérete',
            //     key: 'size',
            //     width: '25',
            // },
            {
                title: 'Műveletek',
                key: 'operation',
                fixed: 'right',
                width: 100,
                scopedSlots: { customRender: 'actions-col' }
            }
            ];
            return columns;
        }
    },

    methods: {
        editUser(record) {
            this.$emit('editUser', record);
        },
        deleteUser(record) {
            this.$emit('deleteUser', record);
        },
        rowkeyGen(data) {
            return data.id;
        },
        switchUserActiveState(activeState, record) {
            this.$emit('switchActive', {activeState, record})
        }
    }

}
</script>

<style>

</style>